import React from 'react';
import { View } from 'src/components/basic';
import { remCss } from 'src/components/mobile/utils';
import { ClinicHeader } from 'src/components/mobile/ClinicHeader';

import { rgba, scssVariables as variables } from 'src/helpers';
import { DoctorsTab } from './DoctorsTab';
import { TreatmentsTab } from './TreatmentsTab';
import { ContactTab } from './ContactTab';
import { GalleryTab } from './GalleryTab';

export const Main = ({
  clinic,
  activeTab,
  onActiveTab,
  onDoctorItem,
  onManagerItem,
  onChatSupport,
  currency,
  onLocation
}) => {
  return (
    <View
      style={{
        height: '100%',
        backgroundColor: 'white',
        gap: remCss(15)
      }}
    >
      <View
        style={{
          height: '100%',
          backgroundColor: rgba(variables['colors-mc-primary'], 0.05),
          gap: remCss(15)
        }}
      >
        <ClinicHeader clinic={clinic} activeTab={activeTab} onActiveTab={onActiveTab} />
        {activeTab === 'doctors' && <DoctorsTab clinic={clinic} onDoctorItem={onDoctorItem} />}
        {activeTab === 'contact' && (
          <ContactTab
            clinic={clinic}
            onManagerItem={onManagerItem}
            onLocation={onLocation}
            onChatSupport={onChatSupport}
          />
        )}
        {activeTab === 'treatments' && <TreatmentsTab clinic={clinic} currency={currency} />}
        {activeTab === 'gallery' && <GalleryTab clinic={clinic} />}
      </View>
    </View>
  );
};
